import { AuditStatus } from 'src/contstant/commonLabels';
import { Persona } from 'src/contstant/Persona';
import { Audit, GetAuditSummaryResponse } from 'src/types/helios/Audit';
import { Question } from 'src/types/helios/Question';
import { AuditQuestions } from 'src/types/helios/SearchAuditQuestions';
import { BusinessUnit } from 'src/types/orbit/BusinessUnit';
import { Division } from 'src/types/orbit/Division';
import { Permission } from 'src/types/orbit/Permission';
import { Role } from 'src/types/orbit/Roles';

//this file is temprary. it will be deleted when it integrate apis.

export interface DivisonItem {
  division: string;
  created: string;
  status: boolean;
}
export interface TeamsItem {
  businessunit: string;
  divisions: DivisonItem[];
  updated: string;
  status: boolean;
}

export const teamsData: TeamsItem[] = [
  {
    businessunit: 'AMZL',
    status: true,
    divisions: [
      {
        division: 'SC',
        created: '06-April',
        status: true,
      },
      {
        division: 'FED',
        created: '06-April',
        status: true,
      },
      {
        division: 'SCW',
        created: '06-April',
        status: true,
      },
    ],
    updated: '22-April',
  },
  {
    businessunit: 'Whole Food',
    status: true,
    divisions: [
      {
        division: 'QQd',
        created: '06-April',
        status: true,
      },
      {
        division: 'GFDE',
        created: '06-April',
        status: true,
      },
      {
        division: 'VVV',
        created: '06-April',
        status: true,
      },
    ],
    updated: '22-June',
  },
  {
    businessunit: 'Air',
    status: true,
    divisions: [
      {
        division: 'EE',
        created: '06-April',
        status: true,
      },
      {
        division: 'CC',
        created: '06-April',
        status: true,
      },
      {
        division: 'DEE',
        created: '06-April',
        status: true,
      },
    ],
    updated: '03-Feb',
  },
  {
    businessunit: 'AMXL',
    status: true,
    divisions: [
      {
        division: 'DD',
        created: '06-April',
        status: true,
      },
      {
        division: 'GGF',
        created: '06-April',
        status: true,
      },
      {
        division: 'WGD',
        created: '06-April',
        status: true,
      },
    ],
    updated: '06-April',
  },
  {
    businessunit: 'FC',
    status: true,
    divisions: [
      {
        division: 'CCC',
        created: '06-April',
        status: true,
      },
      {
        division: 'EEE',
        created: '06-April',
        status: false,
      },
      {
        division: 'BBED',
        created: '06-April',
        status: true,
      },
    ],
    updated: '22-April',
  },
];

import { PermissionResultMap, User } from 'src/types/orbit/User';

export const MOCK_USERS_DATA: User[] = [
  {
    userPermission: {
      userId: 'sailattu',
      program: 'SAT',
      roleId: 'BU_ADMIN',
      businessUnit: 'AMZL',
      userName: 'Kiran',
      isUserActive: true,
      overriddenPermission: ['AMZL_VIEW', 'AMZL_EDIT'],
      rolePermissions: ['VIEW_DASHBOARD', 'MANAGE_USERS'],
      divisions: ['LOGI', 'SEC', 'RETAIL'],
      createdAt: 1641034800000, // 2022-01-01
      createdBy: 'jhon',
      lastUpdatedAt: 1747653592000, // 2023-01-01
      lastUpdatedBy: 'Gustav',
      permissionExpirationDate: '1677628800000',
    },
  },
  {
    userPermission: {
      userId: 'johndoe',
      program: 'SWLC',
      roleId: 'PROGRAM_MANAGER',
      userName: 'John',
      isUserActive: true,
      overriddenPermission: ['ADMIN_DASHBOARD', 'REPORT_GENERATE'],
      rolePermissions: ['', ''],
      divisions: ['GBSA', 'AWS'],
      createdAt: 1646092800000,
      createdBy: 'Peter',
      lastUpdatedAt: 1747826392000,
      lastUpdatedBy: 'James',
      permissionExpirationDate: '1677628800000',
      businessUnit: 'AWS',
    },
  },
];

export const MOCK_DIVISIONS_DATA: Division[] = [
  {
    businessUnit: 'AMZL',
    createdAt: 1747653592000,
    createdBy: 'kiran',
    isActive: true,
    lastUpdatedAt: 1747653592000,
    lastUpdatedBy: 'kiran',
    divisionName: 'GBSA',
    program: 'SAT',
  },
  {
    businessUnit: 'AWS',
    createdAt: 1747653592000,
    createdBy: 'sarah',
    isActive: true,
    lastUpdatedAt: 1747653592000,
    lastUpdatedBy: 'sarah',
    divisionName: 'Cloud Services',
    program: 'CLOUD',
  },
  {
    businessUnit: 'AMZN',
    createdAt: 1747653592000,
    createdBy: 'john',
    isActive: true,
    lastUpdatedAt: 1747653592000,
    lastUpdatedBy: 'john',
    divisionName: 'Retail',
    program: 'ECOM',
  },
  {
    businessUnit: 'AMZL',
    createdAt: 1747653592000,
    createdBy: 'mike',
    isActive: false,
    lastUpdatedAt: 1747653592000,
    lastUpdatedBy: 'mike',
    divisionName: 'Logistics',
    program: 'LOG',
  },
  {
    businessUnit: 'AWS',
    createdAt: 1747653592000,
    createdBy: 'lisa',
    isActive: true,
    lastUpdatedAt: 1747653592000,
    lastUpdatedBy: 'lisa',
    divisionName: 'Security',
    program: 'SEC',
  },
];

export const MOCK_BUSINESS_UNIT_DATA: BusinessUnit[] = [
  {
    businessUnitId: 'AMZL',
    createdAt: '1672570800000',
    lastUpdatedAt: 1747653592000,
    createdBy: 'kiran',
    isActive: true,
    lastUpdatedBy: 'kiran',
    name: 'Amazon Logistics',
    program: 'SAT',
  },
  {
    businessUnitId: 'AWS',
    createdBy: 'sarah',
    isActive: true,
    lastUpdatedBy: 'sarah',
    name: 'Amazon Web Services',
    program: 'CLOUD',
    createdAt: '1672570800000',
    lastUpdatedAt: 1747653592000,
  },
  {
    businessUnitId: 'AMZN_RETAIL',
    createdBy: 'john',
    isActive: true,
    lastUpdatedBy: 'john',
    name: 'Amazon Retail',
    program: 'ECOM',
    createdAt: '1672570800000',
    lastUpdatedAt: 1747653592000,
  },
  {
    businessUnitId: 'PRIME',
    createdBy: 'mike',
    isActive: false,
    lastUpdatedBy: 'mike',
    name: 'Amazon Prime',
    program: 'PRIME_SERVICES',
    createdAt: '1672570800000',
    lastUpdatedAt: 1672570800000,
  },
  {
    businessUnitId: 'AGS',
    createdBy: 'lisa',
    isActive: true,
    lastUpdatedBy: 'lisa',
    name: 'Amazon Global Services',
    program: 'GLOBAL',
    createdAt: '1672570800000',
    lastUpdatedAt: 1672570800000,
  },
];
export const MOCK_ROLES_DATA: Role[] = [
  {
    program: 'SAT',
    businessUnit: 'AMZL',
    roleId: Persona.PLATFORM_ADMIN,
    defaultPermissions: ['ADMIN_DASHBOARD'],
    overriddenPermission: ['ADMIN_DASHBOARD'],
    isRoleActive: true,
    activationHistory: {},

    createdBy: 'john_doe',
    lastUpdatedAt: new Date('2023-07-15T09:30:00Z'),
    lastUpdatedBy: 'jane_smith',
    checked: false,
    name: '',
  },
  {
    program: 'CLOUD',
    businessUnit: 'AWS',
    roleId: 'MANAGER_001',
    defaultPermissions: ['AMZL_VIEW', 'AMZL_EDIT'],
    overriddenPermission: ['AMZL_VIEW', 'AMZL_EDIT'],
    isRoleActive: true,
    activationHistory: {},

    createdBy: 'alice_johnson',
    lastUpdatedAt: new Date('2023-05-20T14:45:00Z'),
    lastUpdatedBy: 'bob_wilson',
    checked: true,
    name: '',
  },
  {
    program: 'ECOM',
    businessUnit: 'AMZN_RETAIL',
    roleId: 'BU_ADMIN',
    defaultPermissions: ['MANAGE_USERS', 'MANAGE_ROLES', 'VIEW_ALL_DATA'],
    overriddenPermission: ['AMZL_VIEW'],
    isRoleActive: true,
    activationHistory: {},

    createdBy: 'carol_davis',
    lastUpdatedAt: new Date('2023-08-01T11:20:00Z'),
    lastUpdatedBy: 'david_miller',
    checked: false,
    name: '',
  },
  {
    program: 'GLOBAL',
    businessUnit: 'AGS',
    roleId: 'PROGRAM_MANAGER',
    defaultPermissions: ['REPORT_GENERATE'],
    overriddenPermission: [],
    isRoleActive: true,
    activationHistory: {},
    createdBy: 'system',
    lastUpdatedAt: new Date('2023-09-10T16:30:00Z'),
    lastUpdatedBy: 'emma_brown',
    checked: true,
    name: '',
  },
];

export const MOCK_PERMISSION_DATA: Permission[] = [
  {
    program: 'SAT',
    permissionId: 'AMZL_VIEW',
    name: 'View AMZL Data',
    desc: 'Permission to view AMZL related data',
    canAddToRole: true,
    canAddToUser: true,
    isActive: true,
    createdAt: new Date('2024-03-25T10:30:00'),
    createdBy: 'kiran',
    lastUpdatedAt: new Date('2024-03-25T10:30:00'),
    lastUpdatedBy: 'kiran',
  },
  {
    program: 'SAT',
    permissionId: 'AMZL_EDIT',
    name: 'Edit AMZL Data',
    desc: 'Permission to modify AMZL related data',
    canAddToRole: true,
    canAddToUser: true,
    isActive: true,
    createdAt: new Date('2024-03-24T15:45:00'),
    createdBy: 'john',
    lastUpdatedAt: new Date('2024-03-24T15:45:00'),
    lastUpdatedBy: 'john',
  },
  {
    program: 'SAT',
    permissionId: 'CREATE_TEST_AUDIT',
    name: 'Create Test Audit',
    desc: 'Permission to create test audit reports',
    canAddToRole: true,
    canAddToUser: false,
    isActive: false,
    createdAt: new Date('2024-03-23T09:15:00'),
    createdBy: 'smith',
    lastUpdatedAt: new Date('2024-03-23T09:15:00'),
    lastUpdatedBy: 'smith',
  },
  {
    program: 'SAT',
    permissionId: 'ADMIN_DASHBOARD',
    name: 'Admin Dashboard Access',
    desc: 'Full access to admin dashboard',
    canAddToRole: true,
    canAddToUser: true,
    isActive: true,
    createdAt: new Date('2024-03-22T14:20:00'),
    createdBy: 'admin',
    lastUpdatedAt: new Date('2024-03-22T14:20:00'),
    lastUpdatedBy: 'admin',
  },
  {
    program: 'SAT',
    permissionId: 'REPORT_GENERATE',
    name: 'Generate Reports',
    desc: 'Permission to generate system reports',
    canAddToRole: true,
    canAddToUser: true,
    isActive: true,
    createdAt: new Date('2024-03-21T11:10:00'),
    createdBy: 'sarah',
    lastUpdatedAt: new Date('2024-03-21T11:10:00'),
    lastUpdatedBy: 'sarah',
  },
];
export const MOCK_PERMISSION_MAPPINGS: PermissionResultMap = {
  'View Roles': true,
  'EditRoles': true,
  'View Permissions': true,
  'Edit Permissions': false,
  'View User': true,
  'EditUser': false,
  'View Location': true,
  'Edit Location': false,
  'View Tags': true,
  'Edit Tags': false,
  'View Business Unit': true,
  'EditBusinessUnit': true,
  'View Division': true,
  'EditDivision': true,
  'View Template': true,
  'Edit Template': false,
  'View Question': true,
  'Edit Question': false,
  'View Category': true,
  'Edit Category': false,
  'View Test Audit': true,
  'Edit Test Audit': false,
  'Perform Test Audit': true,
  'Close Test Audit': false,
  'Reopen Test Audit': true,
  'View Situation Audit': true,
  'Edit Situation Audit': false,
  'Perform Situation Audit': true,
  'Close Situation Audit': false,
  'Reopen Situation Audit': true,
  'View Progress Audit': true,
  'Edit Progress Audit': false,
  'Perform Progress Audit': true,
  'Close Progress Audit': false,
  'Reopen Progress Audit': true,
  'View Calibration Audit': true,
  'Edit Calibration Audit': false,
  'Perform Calibration Audit': true,
  'Close Calibration Audit': false,
  'Reopen Calibration Audit': true,
  'View Task': true,
  'Edit Task': false,
  'Perform Task': true,
  'Cancel Task': false,
  'View Reports': true,
  'Edit Reports': false,
};

export interface Task {
  // Required fields with basic types
  taskId: string;
  taskName: string;
  description: string;
  dueDate: string;
  taskStatus: string;
  assignedBy: string;
  createdBy: string;
  lastUpdatedBy: string;

  // Optional fields with basic types
  taskType?: string;
  auditId?: string;
  questionId?: string;
  subQuestionId?: string;
  businessUnit?: string;
  divisionName?: string;
  locationId?: string;
  duration?: string;
  assigneeLogin?: string;
  auditorObservation?: string;
  actionPerformed?: string;
  comments?: string;

  // Optional fields with complex types
  mediaIdsMap?: {
    [key: string]: string[];
  };

  activityHistory?: Array<{
    timestamp: string;
    action: string;
    performedBy: string;
    details: string;
  }>;

  // Optional dates and metadata
  cancellationDate?: string | null;
  cancelledBy?: string | null;
  createdAt?: string;
  lastUpdatedAt?: string;

  // Translation related fields
  translationstatus?: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE';
  translationVersionsMap?: {
    [locale: string]: number;
  };
  localeTranslationVersionMap?: {
    [locale: string]: {
      taskName: number;
      description: number;
    };
  };

  version?: number;
}

export const mockTasks: Task[] = [
  {
    // Task 1: Active Audit Task
    taskId: 'TASK-2024-001',
    taskName: 'Q1 Safety Audit Review',
    description: 'Conduct quarterly safety protocol assessment and documentation review',
    dueDate: '2024-03-31T23:59:59Z',
    taskStatus: 'IN_PROGRESS',
    assignedBy: 'sarah.manager',
    createdBy: 'system.audit',
    lastUpdatedBy: 'john.auditor',
    taskType: 'AUDIT',
    auditId: 'AUDIT-2024-Q1',
    questionId: 'SFTY-001',
    subQuestionId: '1.2',
    businessUnit: 'OPERATIONS',
    divisionName: 'North America Safety',
    locationId: 'SEA45',
    duration: '15 DAYS',
    assigneeLogin: 'john.auditor',
    auditorObservation: 'Initial safety documentation review completed',
    actionPerformed: 'Completed first round of safety checks',
    comments: 'Pending final verification of emergency protocols',
    mediaIdsMap: {
      DOCUMENTS: ['DOC-001', 'DOC-002'],
      PHOTOS: ['IMG-001', 'IMG-002'],
    },
    activityHistory: [
      {
        timestamp: '2024-03-15T09:00:00Z',
        action: 'CREATED',
        performedBy: 'system.audit',
        details: 'Task generated automatically',
      },
      {
        timestamp: '2024-03-16T10:30:00Z',
        action: 'STARTED',
        performedBy: 'john.auditor',
        details: 'Initial assessment begun',
      },
    ],
    createdAt: '2024-03-15T09:00:00Z',
    lastUpdatedAt: '2024-03-16T10:30:00Z',
    translationstatus: 'IN_PROGRESS',
    version: 2,
  },
  {
    // Task 2: Completed General Task
    taskId: 'TASK-2024-002',
    taskName: 'Employee Training Update',
    description: 'Update employee training materials for Q2',
    dueDate: '2024-02-28T23:59:59Z',
    taskStatus: 'COMPLETED',
    assignedBy: 'mike.lead',
    createdBy: 'mike.lead',
    lastUpdatedBy: 'emma.trainer',
    taskType: 'GENERAL',
    businessUnit: 'HR',
    divisionName: 'Training',
    locationId: 'NYC22',
    duration: '7 DAYS',
    assigneeLogin: 'emma.trainer',
    actionPerformed: 'Updated all training modules',
    comments: 'Successfully completed ahead of schedule',
    createdAt: '2024-02-20T08:00:00Z',
    lastUpdatedAt: '2024-02-25T16:30:00Z',
    version: 1,
  },
  {
    // Task 3: Cancelled Task
    taskId: 'TASK-2024-003',
    taskName: 'Inventory Audit',
    description: 'Perform quarterly inventory audit for warehouse section B',
    dueDate: '2024-04-15T23:59:59Z',
    taskStatus: 'CANCELLED',
    assignedBy: 'robert.manager',
    createdBy: 'robert.manager',
    lastUpdatedBy: 'system.admin',
    taskType: 'AUDIT',
    auditId: 'INV-2024-Q2',
    businessUnit: 'WAREHOUSE',
    locationId: 'CHI33',
    assigneeLogin: 'david.auditor',
    cancellationDate: '2024-04-01T10:00:00Z',
    cancelledBy: 'robert.manager',
    comments: 'Cancelled due to system upgrade schedule conflict',
    createdAt: '2024-03-30T09:00:00Z',
    lastUpdatedAt: '2024-04-01T10:00:00Z',
    version: 1,
  },
  {
    // Task 4: New Assigned Task
    taskId: 'TASK-2024-004',
    taskName: 'Process Implementation Review',
    description: 'Review and document new process implementation results',
    dueDate: '2024-05-30T23:59:59Z',
    taskStatus: 'ASSIGNED',
    assignedBy: 'lisa.director',
    createdBy: 'lisa.director',
    lastUpdatedBy: 'lisa.director',
    taskType: 'GENERAL',
    businessUnit: 'OPERATIONS',
    divisionName: 'Process Improvement',
    locationId: 'LAX12',
    duration: '21 DAYS',
    assigneeLogin: 'mark.analyst',
    createdAt: '2024-04-01T11:00:00Z',
    lastUpdatedAt: '2024-04-01T11:00:00Z',
    translationstatus: 'NOT_STARTED',
    version: 1,
  },
];

export const sampleAuditQuestions: AuditQuestions[] = [
  {
    questionId: '1',
    title: 'Is there a process for monitoring regulatory changes?',
    completionStatus: 'pending',
    tags: {
      category: 'general',
      priority: 'low',
    },
  },
  {
    questionId: '2',
    title:
      'Do associates correctly match SAL package labels to appropriate cart designations?',
    description: 'Sample question for SK category',
    completionStatus: 'completed',
    tags: {
      category: 'SK',
      priority: 'high',
    },
  },
  {
    questionId: '3',
    title: 'Observe and document stowing procedures?',
    description: 'First test question',
    completionStatus: 'in_progress',
    tags: {
      category: 'test',
      priority: 'medium',
    },

    subQuestions: [
      {
        suquestionId: '3-SQ-1',
        title: 'Pass if no vulnerabilities are found',
      },
      {
        suquestionId: '3-SQ-2',
        title: 'First test question',
      },
      {
        suquestionId: '3-SQ-3',
        title: 'Are expense approval workflows being followed?',
      },
      {
        suquestionId: '3-SQ-4',
        title: 'Expense Approval Review',
      },
      {
        suquestionId: '3-SQ-5',
        title: 'Are customer service response times meeting SLA targets',
      },
    ],
  },
];
